import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { func } from 'prop-types';

import Icon from 'components/icon';

import { getLocalization } from '../utils';

const SearchButton = ({ onClick }) => {
    const searchButtonRoot = document.getElementById('search-open-button');
    const elRef = useRef(null);

    if (!elRef.current) {
        elRef.current = document.createElement('div');
    }

    const renderButton = () => (
        <button
            type="button"
            className="header__mobile-actions-item"
            onClick={onClick}
        >
            <span className="u-sr-only">
                {getLocalization('search/searchButton')}
            </span>
            <Icon glyph="search" />
        </button>
    );

    useEffect(() => {
        searchButtonRoot.appendChild(elRef.current);

        return () => {
            searchButtonRoot.removeChild(elRef.current);
        };
    }, [elRef]);

    return ReactDOM.createPortal(renderButton(), elRef.current);
};

SearchButton.propTypes = { onClick: func.isRequired };

export default SearchButton;
